// #genai Placeholder while add-ach / add-card wait for billing eligibility. No controls — the
// route may still redirect.
import React from 'lib/react';
import { EVGrid } from 'lib/components';
import SkeletonLoader from 'commonComponents/skeletonLoader';
import AddPaymentMethodLoaderStyles from './AddPaymentMethodLoaderStyles';

function AddPaymentMethodLoader() {
  const classes = AddPaymentMethodLoaderStyles();

  const sectionSkeleton = (
    <EVGrid className={classes.sections}>
      <SkeletonLoader height="27px" width="240px" />
      <EVGrid className={classes.fieldRow}>
        <SkeletonLoader height="44px" />
        <SkeletonLoader height="44px" />
      </EVGrid>
      <EVGrid className={classes.fieldRow}>
        <SkeletonLoader height="44px" />
        <SkeletonLoader height="44px" />
      </EVGrid>
    </EVGrid>
  );

  return (
    <EVGrid className={classes.card} data-testid="add-payment-method-loader">
      {sectionSkeleton}
      {sectionSkeleton}
    </EVGrid>
  );
}

export default AddPaymentMethodLoader;
